import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { ENDPOINTS } from '../constants/endpoints';

interface LeaderboardEntry {
  userId: number;
  name: string;
  surname: string;
  totalPoints: number;
  rank: number;
  isCurrentUser: boolean;
}

interface LeaderboardResponse {
  entries: LeaderboardEntry[];
  currentUserRank: number | null;
  currentUserEntry: LeaderboardEntry | null;
}

type TimeRange = 'all_time' | 'month_to_date';

async function fetchLeaderboard(
  range: TimeRange,
  organisationId: number,
): Promise<LeaderboardResponse> {
  const response = await apiFetch(ENDPOINTS.LEADERBOARD(range, organisationId));

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to fetch leaderboard');
  }

  return response.json();
}

export function useLeaderboard(
  range: TimeRange,
  organisationId: number | undefined,
) {
  return useQuery({
    queryKey: ['leaderboard', range, organisationId],
    queryFn: () => fetchLeaderboard(range, organisationId!),
    enabled: !!organisationId,
  });
}

export type { LeaderboardEntry, LeaderboardResponse, TimeRange };
